import {
  Alert,
  Box,
  Button,
  Modal,
  Paper,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { rutas } from "../../rutas/rutas";
import { getCookie } from "../../utils/getCookie";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "100%", sm: "70%" },
  height: { xs: "80%", sm: "70%" },
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  display: "flex",
};

export const ModalPool = ({ handleClose, open }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [usuario, setUsuario] = useState({});
  const { informacion } = useSelector((state) => state.userSlice);

  const [acumulador, setAcumulador] = useState(0);

  const [disponible, setDisponible] = useState(0);
  const [open2, setOpen2] = useState(false);
  const [error, setError] = React.useState(false);
  const [errorText, setErrorText] = React.useState("Error");

  const handleClose2 = () => setOpen2(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };
  const columns = [
    { id: "usuario", label: "Users", minWidth: 120 },
    { id: "posicion", label: "Position", minWidth: 100 },
    { id: "puntaje", label: "Point", minWidth: 100 },
  ];
  const handleMirar = () => {
    const tokenJWT = getCookie("token");
    axios.get(rutas.mirarPool, { headers: { token: tokenJWT } }).then((res) => {
      if (res.data?.stake) {
        let conteo = 0;
        const row = res.data.stake.map(
          ({ nombre: usuario, posicion, cantidad: puntaje, avatar = "" }) => {
            conteo += puntaje;
            return {
              usuario,
              posicion,
              puntaje,
              avatar,
            };
          }
        );
        setAcumulador(conteo);
        setUsuario(res.data.userStake);
        setRows(row);
      }
    });
  };
  useEffect(() => {
    const reward =
      (usuario?.cantidad / acumulador) * rows?.length * 230 > 0
        ? parseFloat(
            (usuario?.cantidad / acumulador) * rows?.length * 230
          ).toFixed(2)
        : 0;
    setDisponible(reward);
  }, [rows, acumulador]);
  const handleIngresar = () => {
    const tokenJWT = getCookie("token");
    axios
      .get(rutas.ingresoStakePool, { headers: { token: tokenJWT } })
      .then((res) => {
        console.log(res);
        handleMirar();
      })
      .catch((error) => {
        setErrorText(error?.response?.data?.error)
        setError(true)
        setOpen2(true)
      });
  };
  useEffect(() => {
    handleMirar();
  }, []);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ ...style, flexDirection: { xs: "column-reverse", md: "row" } }}
      >
        <Paper
          sx={{
            width: { xs: "95%", md: "50%" },
            height: { md: "40%", lg: "100%" },
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          }}
        >
          <Paper
            sx={{
              width: "100%",
              overflow: "hidden",
              height: "100%",
              background: "rgba(255, 255, 255, 0.1)",
            }}
          >
            <TableContainer
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                height: "90%",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              <Table
                sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={uuidv4()}
                        align={column.align}
                        style={{ background: "#0E1314", color: "white" }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={uuidv4()}
                        >
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  background: "#1E292B",
                                  color: "white",
                                }}
                              >
                                {value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{ height: "35px", display: { xs: "none", md: "block" } }}
            />
          </Paper>
        </Paper>
        <Box
          sx={{
            marginLeft: 1,
            color: "white",
            width: { xs: "95%", md: "50%" },
            height: { xs: "55%", md: "90%" },
          }}
        >
          <Typography
            sx={{
              marginBottom: 2,
              fontSize: "1.5rem",
              textShadow: "1.5px 1.5px 1px orange",
            }}
            textAlign={"center"}
          >
            Pool Power Hueso + Power Energy
          </Typography>
          <Typography
            sx={{ fontSize: "1.1rem", textShadow: "1.5px 1.5px 1px orange" }}
          >
            Instructions: for each user in the pool, 230 bones are added to the
            total bone to be distributed.
          </Typography>
          <Typography sx={{ fontSize: "1.1rem" }}>
            How many $HUESO do I get every 24 hours? <br />
            By participating you will already have a reward of 150 bones plus
            what you earn in the POOL.
            <br />
            The pool is divided among all the members, but the participants with
            the most power will have the best rewards, the power of all your NFT
            will be added up.
          </Typography>
          <Typography sx={{ textTransform: "uppercase" }}>
            TOTAL POOL: {rows?.length * 230} - TOTAL REWARD{" "}
            {parseFloat(disponible + 150)} - Previous Reward{" "}
            {informacion?.rewardPool}
          </Typography>

          <Box
            sx={{
              width: "100%",
              height: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Typography>
              {informacion?.costoPool ? informacion?.costoPool : 20} Energy
            </Typography>
            <Button
              disabled={informacion?.energia?.actual < 20 || informacion?.pool}
              onClick={handleIngresar}
              variant="contained"
            >
              Enter
            </Button>
          </Box>
        </Box>
        <Stack spacing={2} sx={{ width: "100%", position: "absolute" }}>
          <Snackbar open={open2} autoHideDuration={6000} onClose={handleClose2}>
            {error ? (
              <Alert
                onClose={handleClose2}
                severity="error"
                variant="filled"
                sx={{ width: "100%" }}
              >
                {errorText}
              </Alert>
            ) : (
              <Alert
                onClose={handleClose2}
                severity="success"
                variant="filled"
                sx={{ width: "100%" }}
              >
                Success
              </Alert>
            )}
          </Snackbar>
        </Stack>
      </Box>
  
    </Modal>
  );
};
